import { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { SelectVfoCase } from '@/entities/vfo/components/SelectVfoCase';
import { DocumentsFilters } from '@/entities/vfo/types';
import { useFileOptions } from '@/features/vfo/hooks/useFileOptions';
import { Form } from '@/features/vfo/uikit/Form';
import { Select } from '@/features/vfo/uikit/Select';
import { Button } from '@/shared/uikitV2/Button';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { DocumentsFiltersModalProps } from '@/widgets/modals/types';

import { VfoModalContainerV5 } from '../containers/VfoModalContainerV5';

export const DocumentsFiltersModal: FC<DocumentsFiltersModalProps> = ({
  casesFilter,
  fileTypeFilters,
  withCases,
  onApply,
}) => {
  const { t: tc } = useTranslation('common');
  const { t: tw } = useTranslation('widgets/modals', { keyPrefix: 'documentsFilters' });
  const { t: tf } = useTranslation('pages/pageVfoDocuments', { keyPrefix: 'filters' });
  const fileOptions = useFileOptions();
  const modals = useModalsStore();

  const { control, handleSubmit: formHandleSubmit } = useForm<DocumentsFilters>({
    defaultValues: {
      casesFilter,
      fileTypeFilters,
    },
  });

  const onSubmit = (data: DocumentsFilters) => {
    onApply(data);
    modals.closeModal();
  };

  return (
    <VfoModalContainerV5 title={tw('title')}>
      <StyledForm onFinish={formHandleSubmit(onSubmit)}>
        <FormItems>
          <Controller
            control={control}
            name="fileTypeFilters"
            render={({ field }) => (
              <Select
                {...field}
                className="fileSelect"
                mode="multiple"
                placeholder={tf('fileType.placeholder')}
                options={fileOptions}
              />
            )}
          />
          {withCases && (
            <Controller
              control={control}
              name="casesFilter"
              render={({ field }) => (
                <SelectVfoCase {...field} mode="multiple" placeholder={tf('cases.placeholder')} />
              )}
            />
          )}
        </FormItems>
        <Buttons>
          <StyledButton type="default" size="middle" onClick={modals.closeModal}>
            {tc('cancel')}
          </StyledButton>
          <StyledButton type="primary" size="middle" htmlType="submit">
            {tc('apply')}
          </StyledButton>
        </Buttons>
      </StyledForm>
    </VfoModalContainerV5>
  );
};

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Buttons = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
`;

const StyledButton = styled(Button)`
  flex: 1;
`;
